import React, { FunctionComponent } from 'react';
import { usePortalInfo } from 'hooks/usePortalInfo';

export const ResidentsLabel: FunctionComponent<{type?: 'title' | 'contract' | 'contractType', append?: any}> = ({type = 'title', append = null, children}) => {
  const res = usePortalInfo();
  return <>{append} {res[type]} {children}</>;
};